var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow-sm" }, [
    _c(
      "div",
      { staticClass: "card-body" },
      [
        _c("h5", { staticClass: "card-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("pages.account.info.title")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("account-data-view-edit")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }